const DataCenter = () => import('Views/dataCenter/index-new-ui');
const DataMarket = () => import('Views/dataCenter/data-market-new-ui');
const MetaDataCommodityList = () => import('Views/user/metaData-commodity-list-new-ui');
const MetaDataTransactionList = () => import('Views/user/metaData-transaction-list-new-ui');
const MetaDataCollectionList = () => import('Views/user/metaData-collection-list-new-ui');
const MetaDataRecommendList = () => import('Views/user/metaData-recommend-list-new-ui');
const MetaDataAlreadyListedCommodity = () => import('Views/user/metaData-already-listed-commodity-list-new-ui');
const MetaDataNotListedCommodity = () => import('Views/user/metaData-not-listed-commodity-list-new-ui');

export default[
  { path: '/virtual-trading', component: DataCenter },
  { path: '/data-market', component: DataMarket },
  { path: '/metaData-commodity', component: MetaDataCommodityList },
  { path: '/metaData-transaction', component: MetaDataTransactionList },
  { path: '/metaData-collection', component: MetaDataCollectionList },
  { path: '/metaData-recommend', component: MetaDataRecommendList },
  { path: '/metaData-already-listed', component: MetaDataAlreadyListedCommodity },
  { path: '/metaData-data-asset', component: MetaDataNotListedCommodity },
];



// WEBPACK FOOTER //
// ./src/router/dataCenter.js